"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTrackStats = exports.handleIceCandidate = exports.sleep = exports.todo = exports.replaceTrack = void 0;
function todo(name, e = "") {
    console.log(`TODO: ${name}`, e);
}
exports.todo = todo;
function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}
exports.sleep = sleep;
// Helpers
// -----------------
// WEBRTC helpers
// -----------------
function handleIceCandidate(event) {
    let candidate = event.candidate;
    // if candidate is null it means it is the last  message
    if (candidate == null) {
        return {};
    }
    // log("New candidate was created")
    let newCandidate = {
        type: "rtc--candidate",
        candidate: {
            candidate: candidate.candidate,
            sdpMid: candidate.sdpMid,
            sdpMLineIndex: candidate.sdpMLineIndex,
        },
    };
    return newCandidate;
}
exports.handleIceCandidate = handleIceCandidate;
// replace the track removing the old sender if exists
async function replaceTrack(peerConnection, oldSender, track, stream) {
    if (peerConnection == null)
        return null;
    if (oldSender != null) {
        try {
            // console.log("removing sender...", oldSender)
            peerConnection.removeTrack(oldSender);
            // MAGIC: Add delay because it takes a while for the track to be removed succesfully
            await sleep(100); // RECONNECTION TIMER
        }
        catch (err) {
            console.error('error removing', stream.id, JSON.stringify(oldSender));
        }
        // replace track should be better because it just swaps the track
        // however it doesnt work as it adds a noticeable lag in the first 30 seconds of stream
        // follow up on chromium https://bugs.chromium.org/p/chromium/issues/detail?id=980879
        // oldSender.replaceTrack(track)
        // return oldSender
    }
    // part of the issue in line 523, not working in chrome
    // https://developer.mozilla.org/en-US/docs/Web/API/RTCRtpTransceiver/stop
    // peerConnection.getTransceivers().forEach(trans => trans.stop())
    // const newSender = peerConnection.addTransceiver(track, {streams: [stream]});
    const newSender = peerConnection.addTrack(track, stream);
    return newSender;
}
exports.replaceTrack = replaceTrack;
// Utility gets the stats for the audio track
// returns: a string with SampleSize sample rate and channel count
function getTrackStats(stream) {
    let trackSettings = '';
    if (stream && stream.getAudioTracks) {
        stream.getAudioTracks().forEach((track) => {
            var _a;
            const settings = track.getSettings();
            trackSettings = `${settings.sampleSize}bit @${(_a = settings.sampleRate) !== null && _a !== void 0 ? _a : 0 / 1000}KHz - ${(settings.channelCount == 1) ? 'Mono' : 'Stereo'}`;
        });
    }
    return trackSettings;
}
exports.getTrackStats = getTrackStats;
